module.exports = __webpack_public_path__ + "static/img/笔芯.8021cd0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/笔芯.svg
// module id = pO0J
// module chunks = 21